import './PhotoAlbum.scss';

import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Button, Carousel, Modal } from 'antd';
import React, { useState } from 'react';

import delete_icon from '../../../../../../../../assets/images/MembersArea/MyProfile/delete_icon.svg';
import ImageN from '../../../../../../../../components/ImageN/ImageN';
import ImageNPreview from '../../../../../../../../components/ImageNPreview/ImageNPreview';
import SuccessMessage from '../../../../../../../../components/SuccessMessage/SuccessMessage';
import { deleteGalleryImage } from '../../../../../../../../services/profile-service/profile.service';
import { getToken } from '../../../../../../../../services/token-service/token.service';
import { getUserProfileWithGallery } from '../../../../../../../../services/user-service/user.service';

const PhotoAlbum = (props) => {
  const {
    galleryImages,
    userData,
    visible,
    setVisible,
    hideModal,
    slider,
    currentImg,
    setGalleryImages,
  } = props;

  const classes = ['PhotoAlbum'];
  if (props.className) {
    classes.push(props.className);
  }
  const token = getToken();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [showSuccesMessage, setShowSuccesMessage] = useState(false);
  const [showFailureMessage, setShowFailureMessage] = useState(false);
  const userID = userData?.profile?.id;
  const showModalDelete = () => {
    setIsModalVisible(true);
  };

  const handleCancelModal = () => {
    setIsModalVisible(false);
  };
  //calculate time

  function timeSince(date) {
    var seconds = Math.floor((new Date() - date) / 1000);

    var interval = seconds / 31536000;

    if (interval > 1 && interval < 2) {
      return Math.floor(interval) + ' year ago';
    }
    if (interval > 2) {
      return Math.floor(interval) + ' years ago';
    }
    interval = seconds / 2592000;
    if (interval > 1 && interval < 2) {
      return Math.floor(interval) + ' month ago';
    }
    if (interval > 2) {
      return Math.floor(interval) + ' months ago';
    }
    interval = seconds / 86400;
    if (interval > 1 && interval < 2) {
      return Math.floor(interval) + ' day ago';
    }
    if (interval > 2) {
      return Math.floor(interval) + ' days ago';
    }
    interval = seconds / 3600;
    if (interval > 1 && interval < 2) {
      return Math.floor(interval) + ' hour ago';
    }
    if (interval > 2) {
      return Math.floor(interval) + ' hours ago';
    }
    interval = seconds / 60;
    if (interval > 1 && interval < 2) {
      return Math.floor(interval) + ' minute ago';
    }
    if (interval > 2) {
      return Math.floor(interval) + ' minutes ago';
    }
    return Math.floor(seconds) + ' seconds ago';
  }

  const SamplePrevArrow = (props) => {
    const { className, style, onClick } = props;

    return (
      <div
        className={className}
        style={{
          ...style,
          color: 'black',
          fontSize: '0px',
          lineHeight: '1.5715',
        }}
        onClick={onClick}
      >
        <LeftOutlined style={{ color: '#808080', fontSize: 25 }} />
      </div>
    );
  };

  const SampleNextArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          color: 'black',
          fontSize: '0px',
          lineHeight: '1.5715',
        }}
        onClick={onClick}
      >
        <RightOutlined style={{ color: '#808080', fontSize: 25 }} />
      </div>
    );
  };

  const settings = {
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };

  const handleCancel = () => {
    setVisible(false);
  };

  //delete images

  const deletePhotoFailed = (err) => {
    console.log(err);
    setShowFailureMessage(true);
  };

  const deletePhotoSuccess = () => {
    setShowSuccesMessage(true);
    getUserProfileWithGallery(userID).then((data) => {
      setGalleryImages(data.data.data.gallery_images);
      setVisible(false);
    });
  };

  const handleOk = (image_name) => {
    setIsModalVisible(false);
    deleteGalleryImage(image_name, token).then(deletePhotoSuccess).catch(deletePhotoFailed);
  };

  return (
    <div className="PhotoAlbum">
      <SuccessMessage
        className="success-message photo-album-delete-success"
        message={'Photos successfully deleted!'}
        showMessage={showSuccesMessage}
        setShowMessage={setShowSuccesMessage}
      />
      <SuccessMessage
        className="failure-message photo-album-delete-fail"
        message={'Fail to delete photo'}
        showMessage={showFailureMessage}
        setShowMessage={setShowFailureMessage}
      />
      {galleryImages ? (
        <Modal visible={visible} onCancel={handleCancel} title={null} footer={null}>
          <div className="PhotoAlbum">
            <Carousel
              arrows
              {...settings}
              ref={(ref) => {
                slider.current = ref;
              }}
            >
              {galleryImages
                ? galleryImages.map((img, index) => {
                    return (
                      <div className="CarouselPage" key={index}>
                        <ImageNPreview
                          name={img?.thumbnail_url}
                          nameFullSize={img?.url}
                          className={'PhotoAlbumImage'}
                          classNameImg={'PhotoAlbumImageImg'}
                          type="gallery_images"
                        />
                        <div className="PhotoAlbumImageInfoWrapper">
                          <div className="PhotoAlbumImageInfo">
                            <ImageN //thumb
                              name={userData?.profile?.avatar_image?.thumbnail_url}
                              classNameImg="PhotoAlbumAvatar"
                              className="PhotoAlbumAvatarWrapp"
                              type="profile_image"
                            />
                            <div className="PhotoALbumImageDetails">
                              <p className="GaleryImageUsername">{userData?.profile?.username}</p>
                              <p className="GalleryImageCreatedAt">
                                {timeSince(new Date(img?.created_at))}
                              </p>
                            </div>
                          </div>
                          <div className="DeleteIconWrapper" onClick={showModalDelete}>
                            <img alt="delete icon" src={delete_icon} className="DeleteIcon"></img>
                          </div>
                        </div>
                      </div>
                    );
                  })
                : null}
            </Carousel>
          </div>
        </Modal>
      ) : (
        <Modal visible={visible} onCancel={hideModal} title={null} footer={null}>
          <p>No Photos in the album</p>
        </Modal>
      )}
      <Modal
        className="DeleteModal"
        title="Delete photo"
        visible={isModalVisible}
        // onOk={hideModal}
        onCancel={handleCancelModal}
        footer={[
          <Button key="back" onClick={handleCancelModal}>
            No
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={() => {
              handleOk(currentImg.name);
            }}
          >
            Yes
          </Button>,
        ]}
      >
        <p className="DeletePhotoText">Are you sure you want to delete this photo?</p>
      </Modal>
    </div>
  );
};

export default PhotoAlbum;
